export default {
  name: "Application Documents",
  pageInfo: {
    text: "Below, you will find a summary of the documents that you have uploaded to this application throughout the form. You may also add and categorize additional supplemental documents below.",

    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "files",
          widget: "application_documents",
          validate: [],
          checkDocuments: [
            "jobDutiesFiles",
            "coveredByAcwiaFiles",
            "cbaFiles",
            "cbaEmployerLetterFiles",
            "cbaUnionLetterFiles",
            "surveyFiles",
            "surveyFormEta9165Files",
            "sportsLeagueOrganizationFiles",
            "sportsLeagueLetterFiles",
            "sportsLeagueUnionFiles",
          ],
          modal: {
            machine_name: "application_documents",
            name: "Application Documents",
            widget: "file_upload",
            label:
              "<span>Read and agree to all the application terms, assurances, and obligations contained in <u>Appendix A</u> and attach a signed and dated copy with this application.</span>",
            fileTypes: [".pdf", ".png", ".jpg"],
          },
        },
      ],
    },
  ],
};
